// removed by extract-text-webpack-plugin
module.exports = {"root":"Spinner__root___Qw9PH"};